import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;

  & > img {
    width: 100%;
    max-width: 300px;
    max-height: 200px;

    ${({ theme }) => theme.mediaQueries.DESKTOP_UP} {
      max-width: 400px;
      max-height: 265px;
    }
  }

  & > h1 {
    margin-bottom: 2px;
    margin-top: 5px;
    text-align: center;
  }

  & > p {
    margin-bottom: 0px;
    text-align: center;
    margin-top: 4px;
  }

  & a {
    margin-top: 3px;
  }
`;

export const ButtonGroups = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  gap: 0.5rem;

  button + button {
    margin-top: 0.5rem;
  }
`;
